import * as React from 'react'
import { Route, Redirect, RouteComponentProps } from 'react-router-dom'
import type { RouteProps } from 'react-router-dom'

import { useKeycloak } from '@react-keycloak/web'
import {useAxios} from "../utils/hooks";
import {openNotification} from "../utils/openNotification";
import { useHistory } from "react-router-dom";

interface PrivateRouteParams extends RouteProps {
    component: | React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
    roles: any[];
}


export function PrivateRoute({component: Component, roles, ...rest}: PrivateRouteParams) {

    const { keycloak } = useKeycloak()
    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");
    const [onboardingStatus, setOnboardingStatus] = React.useState<string | null>(null);
    const history = useHistory();
    const myStorage = window.localStorage;



    const isAutherized = (roles: any[]) => {
        if (keycloak != null && keycloak.authenticated && keycloak && roles) {

            let obj: any = JSON.parse(JSON.stringify(keycloak.tokenParsed));

            if(keycloak.tokenParsed != null){
                myStorage.setItem("username", obj.preferred_username)
            }

            return roles.some(r => {
                const realm =  keycloak.hasRealmRole(r);
                const resource = keycloak.hasResourceRole(r);
                return realm || resource;
            });
        }
        return false;
    }

    React.useEffect(() => {

        if (axiosInstance.current != null && keycloak && keycloak.authenticated) {

            axiosInstance.current
                .get('/resource/onboarding/get-onboarding-status')
                .then((response) => {
                    setOnboardingStatus(response.data);

                    if (
                        window.location.pathname != '/onboardingfinish' &&
                        response.data !== 'COMPLETED' &&
                        (keycloak.hasRealmRole('EUDR_SUPPL_ADMIN') || keycloak.hasResourceRole('EUDR_SUPPL_ADMIN'))
                    ) {
                        history.push("/onboardingfinish");
                    }
                })
                .catch((error: any) => {
                    openNotification('error', error);
                });
        }
    }, []);


    return (
        <Route
            {...rest}
            render={(props) => {
                if (!keycloak.authenticated) {
                    return (
                        <ExternalRedirect
                            exact={true}
                            path={''}
                            link={keycloak.createLoginUrl()}
                        />
                    );
                }

                if (!isAutherized(roles)) {
                    return <span>Access Denied</span>;
                }

                return <Component {...props} />;
            }}
        />
    )
}


interface Props {
    exact?: boolean;
    link: string;
    path: string;
    sensitive?: boolean;
    strict?: boolean;
}

const ExternalRedirect: React.FC<Props> = (props: Props) => {
    const { link, ...routeProps } = props;

    return (
        <Route
            {...routeProps}
            render={() => {
                window.location.replace(props.link);
                return null;
            }}
        />
    );
};
